export default class SweetalertManager {

    static showAlert(swal, config) {
        swal({
            title: (config.lang === 'it') ? 'Avviso' : 'Warning',
            text: config.text,
            type: 'warning',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-primary',
            confirmButtonColor: "#6daa47"           // colore repalnet
        })
    }

    static showPromiseAlert(swal, config) {
        return swal({
            title: (config.lang === 'it') ? 'Conferma Operazione' : 'Confirm Operation',
            text: config.text,
            type: 'warning',
            showCancelButton: true,
            buttonsStyling: false,
            confirmButtonText: (config.lang === 'it') ? 'Conferma' : 'Confirm',
            cancelButtonText: (config.lang === 'it') ? 'Annulla' : 'Cancel',
            confirmButtonClass: 'btn m-r-5 btn-primary',
            cancelButtonClass: 'btn btn-default',
        })
    }


    // IMPLEMENTATION

    /*
    SweetalertManager.showAlert(this.$swal, {
        lang: 'it',
        text: 'Intervallo date errato.'
    })
    */

    /*
    SweetalertManager.showPromiseAlert(this.$swal, {
                    lang: 'it',
                    text: 'Eliminare la riga selezionata?'
                })
                    .then(result => {
                        if (result.value) {
                            this.$swal('Deleted', 'You successfully deleted this file', 'success')
                        } else {
                            this.$swal('Cancelled', 'Your file is still intact', 'info')
                        }
                    })
    */


}
